import { u as i } from "../../../../styled-components.browser.esm-BFmoFexH.js";
import { Row as o } from "antd";
const n = i(o)`
    display: flex;
    flex-direction: column;
    ${({ $layout: t }) => t === "default" ? "gap: 16px;margin: 6px 75px 6px 22px;" : ""}
    line-height: 20px;
`, r = i.div`
    ${({ $layout: t }) => t === "default" ? "width: 550px;" : ""}
`;
export {
  r as MetricOptionContainer,
  n as MetricOptionContainerRow
};
//# sourceMappingURL=MetricOptionContainerRow.js.map
